import { render, staticRenderFns } from "./Jam.vue?vue&type=template&id=77504000&scoped=true"
import script from "./Jam.vue?vue&type=script&lang=js"
export * from "./Jam.vue?vue&type=script&lang=js"
import style0 from "./Jam.vue?vue&type=style&index=0&id=77504000&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77504000",
  null
  
)

export default component.exports